import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ObserverMapFacadeService } from '../../services/observer-map-facade.service';

@Component({
  selector: 'app-observer-photo-modal',
  imports: [DatePipe],
  templateUrl: './observer-photo-modal.component.html',
  styleUrl: './observer-photo-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObserverPhotoModalComponent {
  protected readonly facade = inject(ObserverMapFacadeService);
}
